import { render, staticRenderFns } from "./AppTitlebarMenu.vue?vue&type=template&id=53fd53ca&scoped=true"
import script from "./AppTitlebarMenu.vue?vue&type=script&lang=js"
export * from "./AppTitlebarMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fd53ca",
  null
  
)

export default component.exports